import { StudentSpecificScale } from './student-specific-scale';
import { AssessmentScaleRange } from './assessment-scale-range';

export class AssessmentScale {
  assessmentScaleId?: number;
  assessmentId: number;
  sectionSubjectId: number;
  scaleGroupId: number;
  scaleMethodId: number;
  scaleStatusId: number;
  scaleValue: number = 0;
  fromMark: number;
  toMark: number;
  studentSpecificScales: StudentSpecificScale[] = [];
  assessmentScaleRanges: AssessmentScaleRange[] = [];
}
